import { Routes } from "@angular/router";
import { AuthGuardService } from "./guards/auth-guard.service";

export const appRoutes: Routes = [
	{
		path: "encounters",
		loadChildren: () => import("./modules/encounters/encounters.module").then((m) => m.EncountersModule),
	},
	{
		path: "education",
		loadChildren: () => import("./modules/education/education.module").then((m) => m.EducationModule),
	},
	{
		path: "my-protocols",
		canActivate: [AuthGuardService],
		data: { preload: true },
		loadComponent: () =>
			import("./modules/protocols/my-protocols/my-protocols.component").then((m) => m.MyProtocolsComponent),
	},
	{
		path: "protocols",
		data: { preload: true },
		loadChildren: () => import("./modules/protocols/protocols.module").then((m) => m.ProtocolsModule),
	},
	{
		path: "pathways",
		loadChildren: () => import("./modules/pathways/pathways.module").then((m) => m.PathwaysModule),
	},
	{
		path: "patients",
		loadChildren: () => import("./modules/patients/patients.module").then((m) => m.PatientsModule),
	},
	{
		// Public: reached from the link emailed to the patient ({WEB_APP}/patient-portal#token=…).
		path: "patient-portal",
		loadChildren: () => import("./modules/patient-portal/patient-portal.module").then((m) => m.PatientPortalModule),
	},
	{
		path: "admin",
		loadChildren: () => import("./modules/supreme-admin/supreme-admin.module").then((m) => m.SupremeAdminModule),
	},
	{
		path: "institutes",
		loadChildren: () => import("./modules/institutes/institutes.module").then((m) => m.InstitutesModule),
	},
	{
		path: "directory",
		loadChildren: () => import("./modules/directory/directory.module").then((m) => m.DirectoryModule),
	},
	{
		path: "videos",
		data: { preload: true },
		loadChildren: () => import("./modules/videos/videos.module").then((m) => m.VideosModule),
	},
	{
		path: "quality",
		loadChildren: () => import("./modules/quality/quality.module").then((m) => m.QualityModule),
	},
	{
		path: "tools",
		loadChildren: () => import("./modules/tools/tools.module").then((m) => m.ToolsModule),
	},
	{
		path: "glasses",
		loadChildren: () => import("./modules/glasses/glasses.module").then((m) => m.GlassesModule),
	},
	{
		path: "users",
		loadChildren: () => import("./modules/users/users.module").then((m) => m.UsersModule),
	},
	{
		path: "formulas",
		loadChildren: () => import("./modules/formulas/formulas.module").then((m) => m.FormulasModule),
	},
	{
		path: "dashboard",
		loadChildren: () => import("./modules/dashboard/dashboard.module").then((m) => m.DashboardModule),
	},
	{
		path: "pharmacy",
		data: { preload: true },
		loadChildren: () => import("./modules/pharmacy/pharmacy.module").then((m) => m.PharmacyModule),
	},
	{
		path: "catalog",
		canActivate: [AuthGuardService],
		loadChildren: () => import("./modules/catalog/catalog.routes").then((m) => m.catalogRoutes),
	},
	{
		path: "settings-user",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/users/settings-user/settings-user.component").then((m) => m.SettingsUserComponent),
	},
	{
		path: "home",
		canActivate: [AuthGuardService],
		loadComponent: () => import("./modules/home/home.component").then((m) => m.HomeComponent),
	},
	{
		path: "statistics",
		loadChildren: () => import("./modules/statistics/statistics.module").then((m) => m.StatisticsModule),
	},
	{
		path: "misc",
		loadChildren: () => import("./modules/misc/misc.module").then((m) => m.MiscModule),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/snake",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/medical-snake/medical-snake.component").then((m) => m.MedicalSnakeComponent),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/triage",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/triage-rush/triage-rush.component").then((m) => m.TriageRushComponent),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/invaders",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/germ-invaders/germ-invaders.component").then((m) => m.GermInvadersComponent),
	},
	{
		path: "auth",
		loadComponent: () => import("./modules/auth/auth/auth.component").then((m) => m.AuthComponent),
	},
	{
		path: "",
		canActivate: [AuthGuardService],
		loadComponent: () => import("./modules/home/home.component").then((m) => m.HomeComponent),
	},
	{ path: "**", redirectTo: "protocols" },
];
